module.exports = __webpack_public_path__ + "assets/img/CloudMarket.a37d1be6.png";